import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Publicacion } from '@app/shared';
import { EndpointService } from '@app/core';

@Injectable()
export class PublicationDataService {

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  /**
   * Obtiene la publicacion del documento
   *
   * @param {number} idTask
   * @param {number} idDocument
   * @returns {Observable<Publicacion>}
   * @memberof LiquidationDeterminationDataService
   */
  getPublication(idTask: number, idDocument: number): Observable<Publicacion> {
    const formData = {
      id_tarea: idTask,
      id_documento: idDocument
    };
    return new Observable(obs => {
      this.http.skipErrorHandler().post<Publicacion>( this.api.get('publicationService'), formData)
        .subscribe(
          res => {
            if (res && res.fecha_publicacion) {
              const dt = new Date(res.fecha_publicacion);
              res.fecha_publicacion = dt.toLocaleString('es-CO');
            }
            obs.next(res);
          },
          err => {
            this.toastr.error('Se produjo un error al realizar la petición al servidor.', 'Ocurrió un error');
            obs.error(err);
          }
        );
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/all/publication/shared/publication.data.service.ts